import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login/login'
import Pending from '@/components/login/pending'
import Register from '@/components/login/register'

//////////////////////////////////////////////
///////// SETTINGS SECTION //////////////////
////////////////////////////////////////////
import SettingsStart from '@/components/settings/settings-start'
import Settings from '@/components/settings/settings'

// Company Settings
import Branches from '@/components/settings/company/branches'
import Companies from '@/components/settings/company/companies'
import Departments from '@/components/settings/company/departments'
import Designations from '@/components/settings/company/designations'
import Divisions from '@/components/settings/company/divisions'
import Groups from '@/components/settings/company/groups'
import Holidays from '@/components/settings/company/holidays'

// Users and Control Settings
import Profile from '@/components/settings/profile/profile'
import Users from '@/components/settings/users/users'
import Roles from '@/components/settings/users/roles'
import Permissions from '@/components/settings/users/permissions'
import Teams from '@/components/settings/users/teams'

// HR Settings
import SettingsHR from '@/components/settings/hr/general'
import LeaveTypes from '@/components/settings/hr/leave-types'
import ShiftCategories from '@/components/settings/hr/shift-categories'


////////////////////////////////////////////////
///////////////// HR Modules ///////////////////
////////////////////////////////////////////////
import Dashboard from '@/components/hr/dashboard'
import SearchAttendance from '@/components/hr/attendance/attendance'
import ShiftPlan from '@/components/hr/attendance/shift-plans'
import ShiftsList from '@/components/hr/attendance/shifts'
import EmployeeList from '@/components/hr/employees/employees'
import LeavesList from '@/components/hr/leaves/leaves'
import Machines from '@/components/hr/attendance/machines'



import store from './../store/store'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Dashboard,
    },
    {
      path: '/dashboard',
      component: Dashboard,
    },
    {
      path: '/hr/dashboard',
      component: Dashboard,
    },
    {
      path: '/hr/attendance',
      component: SearchAttendance,
    },
    {
      path: '/hr/shifts/shift-plans',
      component: ShiftPlan,
    },
    {
      path: '/hr/shifts',
      component: ShiftsList,
    },
    {
      path: '/hr/employees',
      component: EmployeeList,
      props: true,
    },
    {
      path: '/hr/machines',
      component: Machines,
    },
    {
      path: '/hr/leaves',
      component: LeavesList,
    },
    {
      path: '/login',
      component: Login,
      props: (route) => ({ redirect: route.query.redirect })
    },
    {
      path: '/pending',
      component: Pending
    },
    {
      path: '/register',
      component: Register
    },
    {
      path: '/settings',
      component: Settings,
      children:[
        {
          path: '',
          component: SettingsStart,
        },
        {
          path: 'profile',
          component: Profile,
        },
        {
          path: 'users',
          component: Users,
        },
        {
          path: 'roles',
          component: Roles,
        },
        {
          path: 'roles/:roleID',
          component: Permissions,
        },
        {
          path: 'company/branches',
          component: Branches,
        },
        {
          path: 'company/companies',
          component: Companies,
        },
        {
          path: 'company/departments',
          component: Departments,
        },
        {
          path: 'company/designations',
          component: Designations,
        },
        {
          path: 'company/divisions',
          component: Divisions,
        },
        {
          path: 'company/group',
          component: Groups,
        },
        {
          path: 'hr/general',
          component: SettingsHR,
        },
        {
          path: 'company/holidays',
          component: Holidays,
        },
        {
          path: 'hr/leaves',
          component: LeaveTypes,
        },
        {
          path: 'hr/shift_categories',
          component: ShiftCategories,
        },
      ]
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js